import * as _ from 'lodash';

class CheckBoxController {
    constructor() {
        this.listeners = {};
        this.value = false;
        this.disabled = false;
    }

    register(name, handler) {
        this.listeners[name] = handler;
    }

    remove(name) {
        delete this.listeners[name];
    }

    _trigger(name) {
        _.each(this.listeners, (v, k) => {
            if (k !== name) {
                v();
            }
        });
    }

    updateDisabled(name, newvalue) {
        let value = !!newvalue;
        if (value !== this.disabled) {
            this.disabled = value;
            this._trigger(name);
        }
    }

    update(name, newvalue) {
        let value = !!newvalue;
        if (!this.disabled && value !== this.value) {
            this.value = value;
            this._trigger(name);
        }
    }
}

angular.module("tromanWeb").directive("ergoCheckbox", [function () {
    return {
        restrict: "EA",
        require: ['ergoCheckbox', '?ngModel'],
        template: '<input type="checkbox" />',
        controller: CheckBoxController,
        link: function (scope, element, attributes, ctrls) {
            var ergoCheckbox = ctrls[0];
            var ngModel = ctrls[1];

            var checkbox = element.children('input');
            ergoCheckbox.register('dom', () => {
                checkbox[0].checked = ergoCheckbox.value;
            });

            checkbox.on('change', () => {
                ergoCheckbox.update('dom', checkbox[0].checked, ergoCheckbox.disabled);
            });

            if (attributes.ergoDisabled) {
                scope.$watch(attributes.ergoDisabled, disabled => {
                    checkbox[0].disabled = disabled;
                    ergoCheckbox.updateDisabled('disabled', disabled);
                });
            }

            if (ngModel) {
                ergoCheckbox.register('model', function () {
                    ngModel.$setViewValue(ergoCheckbox.value);
                });

                ngModel.$render = () => {
                    ergoCheckbox.update('model', ngModel.$viewValue);
                };

                ngModel.$isEmpty = function (value) {
                    return value === false;
                };

                ngModel.$formatters.push(function (value) {
                    return angular.equals(value, true);
                });

                ngModel.$parsers.push(function (value) {
                    return value ? true : false;
                });
            }
        }
    };
}]);
